<template>
  <div class="pemberkasan">
    <div class="navbar">
      <div @click="$router.go(-1)">
        <back />
      </div>
      <div>Pemberkasan</div>
    </div>

    <div class="body">

      <div class="info">
        <ul>
          <li>Ukuran file maksimal 2MB</li>
          <li>Format file yang direkomendasikan adalah jpg & png</li>
        </ul>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="verified" v-if="isVerified">
            <div>
              <img src="/static/icons/checked.svg" width="30" />
            </div>
            <div>Dokumen sudah divalidasi.</div>
          </div>

          <div v-if="isLoading" style="text-align: center; padding: 100px 0;">
            <Spinner />
          </div>
          <div class="media-wrapper" v-else>
            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.foto_full_badan"
              @uploaded="(url) => handleUploaded(url, 'foto_full_badan')" label="Foto Full Badan" />

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.surat_keterangan_sehat"
              @uploaded="(url) => handleUploaded(url, 'surat_keterangan_sehat')" label="Surat Keterangan Sehat" />

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.identitas"
              @uploaded="(url) => handleUploaded(url, 'identitas')" label="Identitas / KTP" />

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.bukti_asal_sekolah"
              @uploaded="(url) => handleUploaded(url, 'bukti_asal_sekolah')" label="Bukti Asal Sekolah" />

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.ijin_orangtua"
              @uploaded="(url) => handleUploaded(url, 'ijin_orangtua')" label="Ijin Orangtua" />

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.ktp_orangtua"
              @uploaded="(url) => handleUploaded(url, 'ktp_orangtua')" label="KTP Orangtua" />

            <!-- <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.surat_tidak_dijamin"
              @uploaded="(url) => handleUploaded(url, 'surat_tidak_dijamin')" label="Surat tidak dijamin kerja" /> -->

            <ImageUpload endpoint="https://api.pspp-integrated.com/v1/berkas/upload_file" :url="file.passpor"
              @uploaded="(url) => handleUploaded(url, 'passpor')" label="Passpor (opsional)" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "./icons/Back.vue";
import Spinner from "./icons/Spinner.vue";
import Close from "./icons/Close.vue";

import ImageUpload from "./ImageUpload.vue";
import { get, post } from "@/api/Api";

export default {
  name: "Pemberkasan",
  components: {
    Back,
    Spinner,
    Close,
    ImageUpload
  },
  data() {
    return {
      isLoading: false,
      file: {},
      isVerified: false,
    };
  },
  methods: {
    async load() {
      this.isLoading = true;

      const r = await get(`/v1/SiswaController/getPemberkasanV2?id_siswa=${this.$store.state.settings.user.id}`)
      if (r.valid && r.data != null) {
        this.file = r.data;
      }

      this.isLoading = false;
    },
    async handleUploaded(url, name) {
      const data = {
        id_siswa: this.$store.state.settings.user.id,
        doc_type: name,
        url
      }

      const r = await post(`/v1/SiswaController/updatePemberkasanV2`, data);
    },
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped lang="scss">
.pemberkasan {
  .navbar {
    background: #fff;
    color: #333;
    padding: 15px;
    font-weight: 600;
    display: grid;
    grid-template-columns: 40px 1fr;
    border-bottom: 1px solid #ccc;
  }

  .info {
    background: #ECF5FF;
    color: #409EFF;
    padding: 15px;
    margin-bottom: 20px;

    ul {
      margin: 0;
      padding: 0 20px;

      li {
        font-size: 14px;
      }
    }
  }

  .body {
    padding: 20px;

    .verified {
      display: grid;
      grid-template-columns: 45px 1fr;
      padding: 15px;
      border: 1px solid #32ba7c;
      margin-bottom: 15px;
      background: #32ba7c;
      border-radius: 6px;
      color: #fff;

      >div {
        display: flex;
        align-items: center;
      }
    }

    .media-wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }

    .card {
      background: #fff;
      border-radius: 6px;
      margin-bottom: 20px;

      .card-title {
        border-bottom: 1px solid #ccc;
        font-weight: 600;
        padding-bottom: 10px;
        margin-bottom: 15px;
      }
    }


  }

  .btn {
    background-color: var(--primary);
    color: #fff;
    padding: 15px;
    outline: none;
    border: 0;
    width: 100%;
    display: block;
    border-radius: 50px;
    font-weight: 600;
    text-transform: uppercase;

    &:active {
      background-color: #12a2ca;
    }

    &.loading {
      background-color: #a0eaff;
    }
  }

  .btn-2nd {
    background-color: #fff;
    color: #f96d01;
    padding: 15px;
    outline: none;
    border: 1px solid #f96d01;
    width: 100%;
    display: block;
    border-radius: 50px;
    font-weight: 600;

    &:active {
      background-color: #eee;
    }
  }

  .modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;

    .modal-header {
      border-bottom: 1px solid #ccc;
      padding: 15px;
      font-size: 14px;
      font-weight: 600;
    }

    .modal-body {
      margin: 15px;

      .btn-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 15px;
      }
    }
  }

  .table-form {
    width: 100%;
    border-collapse: collapse;

    td:first-child {
      width: 140px;
      font-size: 14px;
    }

    input,
    textarea {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 8px;
      width: calc(100% - 12px);
      outline: none;
      margin-bottom: 5px;

      &:focus {
        border: 1px solid var(--primary);
      }

      &.invalid {
        border: 1px solid #f00;
      }
    }
  }

  p.notif {
    font-size: 13px;
    background: rgba(255, 239, 93, 0.479);
    padding: 10px;
    border: 1px solid rgb(250, 227, 100);
    border-radius: 6px;
  }

  .overlay {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
